import {createContext} from 'react'

const InventarioContext = createContext()

export default InventarioContext